//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DataBlockTypeClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';



export type PatchDataBlockTypeQueryParameters = {
  id: number ;
}

export type RemoveDataBlockTypeQueryParameters = {
  id: number ;
}

export type SaveConfigDataBlockTypeQueryParameters = {
  id: number ;
}

export type GetUIConfigsDataBlockTypeQueryParameters = {
  id: number ;
}

export type ResetConfigDataBlockTypeQueryParameters = {
  id: number ;
}

export type SaveToDefaultConfigDataBlockTypeQueryParameters = {
  id: number ;
}

export type GetUIConfigFieldsDataBlockTypeQueryParameters = {
  id: number ;
  configType: Types.UIConfigType ;
}

export function getUrl(): string {
  let url_ = getBaseUrl() + "/api/data-blocks/types";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.DataBlockTypeDto[], unknown, Types.DataBlockTypeDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DataBlockTypeDto[], unknown, Types.DataBlockTypeDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'DataBlockTypeClient',
      'get',
    ]);
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
axiosConfig    );
}

export function useGetQuery<TSelectData = Types.DataBlockTypeDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.DataBlockTypeDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.DataBlockTypeDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DataBlockTypeDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DataBlockTypeDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.DataBlockTypeDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.DataBlockTypeDto[] | undefined) => Types.DataBlockTypeDto[], ) {
  queryClient.setQueryData(getQueryKey(),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DataBlockTypeDto[] | undefined) => Types.DataBlockTypeDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/data-blocks/types";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'DataBlockTypeClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockTypeDto, unknown, Types.CreateDataBlockTypeDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockTypeDto, unknown, Types.CreateDataBlockTypeDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateDataBlockTypeDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getDataBlockTypesForEditingUrl(): string {
  let url_ = getBaseUrl() + "/api/data-blocks/types/edit";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDataBlockTypesForEditingDefaultOptions: Omit<UseQueryOptions<Types.DataBlockTypeListDto[], unknown, Types.DataBlockTypeListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DataBlockTypeListDto[], unknown, Types.DataBlockTypeListDto[]>, 'queryFn'>> = {
};
export function getGetDataBlockTypesForEditingDefaultOptions() {
  return getDataBlockTypesForEditingDefaultOptions;
};
export function setGetDataBlockTypesForEditingDefaultOptions(options: typeof getDataBlockTypesForEditingDefaultOptions) {
  getDataBlockTypesForEditingDefaultOptions = options;
}

export function getDataBlockTypesForEditingQueryKey(): QueryKey;
export function getDataBlockTypesForEditingQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'DataBlockTypeClient',
      'getDataBlockTypesForEditing',
    ]);
}
export function __getDataBlockTypesForEditing(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDataBlockTypesForEditing(
axiosConfig    );
}

export function useGetDataBlockTypesForEditingQuery<TSelectData = Types.DataBlockTypeListDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.DataBlockTypeListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDataBlockTypesForEditingQuery<TSelectData = Types.DataBlockTypeListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DataBlockTypeListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DataBlockTypeListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDataBlockTypesForEditing(context, axiosConfig) : __getDataBlockTypesForEditing,
    queryKey: getDataBlockTypesForEditingQueryKey(),
    ...getDataBlockTypesForEditingDefaultOptions as unknown as Omit<UseQueryOptions<Types.DataBlockTypeListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetDataBlockTypesForEditingData(queryClient: QueryClient, updater: (data: Types.DataBlockTypeListDto[] | undefined) => Types.DataBlockTypeListDto[], ) {
  queryClient.setQueryData(getDataBlockTypesForEditingQueryKey(),
    updater
  );
}

export function setGetDataBlockTypesForEditingDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DataBlockTypeListDto[] | undefined) => Types.DataBlockTypeListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/types/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockTypeClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DataBlockTypeDto, unknown, Types.PatchDataBlockTypeDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockTypeDto, unknown, Types.PatchDataBlockTypeDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchDataBlockTypeDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchDataBlockTypeQueryParameters & {
  dto: Types.PatchDataBlockTypeDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockTypeDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchDataBlockTypeQueryParameters}): UseMutationResult<Types.DataBlockTypeDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/types/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockTypeClient',
      'remove',
      id as any,
    ]);
}

export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveDataBlockTypeQueryParameters

export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveDataBlockTypeQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function saveConfigUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/types/{id}/ui-config";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function saveConfigMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockTypeClient',
      'saveConfig',
      id as any,
    ]);
}

export function useSaveConfigMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.EditUIConfigDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.EditUIConfigDto, TContext> {
  const key = saveConfigMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.EditUIConfigDto) => Client.saveConfig(id, dto),
    mutationKey: key,
  });
}
  
type SaveConfig__MutationParameters = SaveConfigDataBlockTypeQueryParameters & {
  dto: Types.EditUIConfigDto;
}

export function useSaveConfigMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SaveConfig__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SaveConfigDataBlockTypeQueryParameters}): UseMutationResult<void, unknown, SaveConfig__MutationParameters, TContext> {
  const key = saveConfigMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SaveConfig__MutationParameters) => Client.saveConfig(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function getUIConfigsUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/types/{id}/ui-config";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getUIConfigsDefaultOptions: Omit<UseQueryOptions<Types.UIConfigDto, unknown, Types.UIConfigDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UIConfigDto, unknown, Types.UIConfigDto>, 'queryFn'>> = {
};
export function getGetUIConfigsDefaultOptions() {
  return getUIConfigsDefaultOptions;
};
export function setGetUIConfigsDefaultOptions(options: typeof getUIConfigsDefaultOptions) {
  getUIConfigsDefaultOptions = options;
}

export function getUIConfigsQueryKey(id: number): QueryKey;
export function getUIConfigsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetUIConfigsDataBlockTypeQueryParameters;

    return trimArrayEnd([
        'DataBlockTypeClient',
        'getUIConfigs',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockTypeClient',
        'getUIConfigs',
        ...params
      ]);
  }
}
export function __getUIConfigs(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getUIConfigs(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetUIConfigsQuery<TSelectData = Types.UIConfigDto, TError = unknown>(dto: GetUIConfigsDataBlockTypeQueryParameters, options?: Omit<UseQueryOptions<Types.UIConfigDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetUIConfigsQuery<TSelectData = Types.UIConfigDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.UIConfigDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetUIConfigsQuery<TSelectData = Types.UIConfigDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UIConfigDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetUIConfigsDataBlockTypeQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UIConfigDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getUIConfigs(context, axiosConfig) : __getUIConfigs,
    queryKey: getUIConfigsQueryKey(id),
    ...getUIConfigsDefaultOptions as unknown as Omit<UseQueryOptions<Types.UIConfigDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetUIConfigsData(queryClient: QueryClient, updater: (data: Types.UIConfigDto | undefined) => Types.UIConfigDto, id: number) {
  queryClient.setQueryData(getUIConfigsQueryKey(id),
    updater
  );
}

export function setGetUIConfigsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UIConfigDto | undefined) => Types.UIConfigDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function resetConfigUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/types/{id}/ui-config/reset";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resetConfigMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockTypeClient',
      'resetConfig',
      id as any,
    ]);
}

export function useResetConfigMutation<TContext>(id: number, options?: Omit<UseMutationOptions<string, unknown, Types.UIConfigTypeDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, Types.UIConfigTypeDto, TContext> {
  const key = resetConfigMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UIConfigTypeDto) => Client.resetConfig(id, dto),
    mutationKey: key,
  });
}
  
type ResetConfig__MutationParameters = ResetConfigDataBlockTypeQueryParameters & {
  dto: Types.UIConfigTypeDto;
}

export function useResetConfigMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<string, unknown, ResetConfig__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ResetConfigDataBlockTypeQueryParameters}): UseMutationResult<string, unknown, ResetConfig__MutationParameters, TContext> {
  const key = resetConfigMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ResetConfig__MutationParameters) => Client.resetConfig(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function saveToDefaultConfigUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/types/{id}/ui-config/save-to-default";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function saveToDefaultConfigMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockTypeClient',
      'saveToDefaultConfig',
      id as any,
    ]);
}

export function useSaveToDefaultConfigMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.EditUIConfigDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.EditUIConfigDto, TContext> {
  const key = saveToDefaultConfigMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.EditUIConfigDto) => Client.saveToDefaultConfig(id, dto),
    mutationKey: key,
  });
}
  
type SaveToDefaultConfig__MutationParameters = SaveToDefaultConfigDataBlockTypeQueryParameters & {
  dto: Types.EditUIConfigDto;
}

export function useSaveToDefaultConfigMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SaveToDefaultConfig__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SaveToDefaultConfigDataBlockTypeQueryParameters}): UseMutationResult<void, unknown, SaveToDefaultConfig__MutationParameters, TContext> {
  const key = saveToDefaultConfigMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SaveToDefaultConfig__MutationParameters) => Client.saveToDefaultConfig(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function getUIConfigFieldsUrl(id: number, configType: Types.UIConfigType): string {
  let url_ = getBaseUrl() + "/api/data-blocks/types/{id}/ui-config/{configType}/fields";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (configType === undefined || configType === null)
  throw new Error("The parameter 'configType' must be defined.");
url_ = url_.replace("{configType}", encodeURIComponent("" + configType));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getUIConfigFieldsDefaultOptions: Omit<UseQueryOptions<Types.UIConfigFieldDto[], unknown, Types.UIConfigFieldDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UIConfigFieldDto[], unknown, Types.UIConfigFieldDto[]>, 'queryFn'>> = {
};
export function getGetUIConfigFieldsDefaultOptions() {
  return getUIConfigFieldsDefaultOptions;
};
export function setGetUIConfigFieldsDefaultOptions(options: typeof getUIConfigFieldsDefaultOptions) {
  getUIConfigFieldsDefaultOptions = options;
}

export function getUIConfigFieldsQueryKey(dto: GetUIConfigFieldsDataBlockTypeQueryParameters): QueryKey;
export function getUIConfigFieldsQueryKey(id: number, configType: Types.UIConfigType): QueryKey;
export function getUIConfigFieldsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, configType,  } = params[0] as GetUIConfigFieldsDataBlockTypeQueryParameters;

    return trimArrayEnd([
        'DataBlockTypeClient',
        'getUIConfigFields',
        id as any,
        configType as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockTypeClient',
        'getUIConfigFields',
        ...params
      ]);
  }
}
export function __getUIConfigFields(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getUIConfigFields(
      context.queryKey[2] as number,       context.queryKey[3] as Types.UIConfigType,axiosConfig    );
}

export function useGetUIConfigFieldsQuery<TSelectData = Types.UIConfigFieldDto[], TError = unknown>(dto: GetUIConfigFieldsDataBlockTypeQueryParameters, options?: Omit<UseQueryOptions<Types.UIConfigFieldDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetUIConfigFieldsQuery<TSelectData = Types.UIConfigFieldDto[], TError = unknown>(id: number, configType: Types.UIConfigType, options?: Omit<UseQueryOptions<Types.UIConfigFieldDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetUIConfigFieldsQuery<TSelectData = Types.UIConfigFieldDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UIConfigFieldDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let configType: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, configType,  } = params[0] as GetUIConfigFieldsDataBlockTypeQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, configType, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UIConfigFieldDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getUIConfigFields(context, axiosConfig) : __getUIConfigFields,
    queryKey: getUIConfigFieldsQueryKey(id, configType),
    ...getUIConfigFieldsDefaultOptions as unknown as Omit<UseQueryOptions<Types.UIConfigFieldDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetUIConfigFieldsData(queryClient: QueryClient, updater: (data: Types.UIConfigFieldDto[] | undefined) => Types.UIConfigFieldDto[], id: number, configType: Types.UIConfigType) {
  queryClient.setQueryData(getUIConfigFieldsQueryKey(id, configType),
    updater
  );
}

export function setGetUIConfigFieldsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UIConfigFieldDto[] | undefined) => Types.UIConfigFieldDto[]) {
  queryClient.setQueryData(queryKey, updater);
}